import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-auth-modal",
  "use": "icon-close-auth-modal-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" id=\"icon-close-auth-modal\">\n  <path d=\"M13.435 12.02l9.9 9.9a1 1 0 01-1.415 1.415l-9.9-9.9-9.899 9.9A1 1 0 11.707 21.92l9.9-9.9-9.9-9.899A1 1 0 112.121.707l9.9 9.9 9.9-9.9a1 1 0 011.414 1.414l-9.9 9.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol